import styled from 'styled-components';
import React, { useState } from 'react';
import { Colors } from '../../style/colors';
import { Success,Error } from '../../constants/images';
import { FieldTypeProps } from '.';
import { ColorState } from '.';

export enum DateTimePickerType {
  date = "date",
  time = "time",
  datetime = "datetime-local"
}

export interface DateTimeFieldOptions {
  dateType: DateTimePickerType;
}

export const DateTimePicker = ({ fieldConfig, onBlur, onFocuse, onFieldChange, colorState, isActive }: FieldTypeProps) => {
  const { name, label } = fieldConfig;
  const {dateType} = fieldConfig.typeOptions as DateTimeFieldOptions;

  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    switch (dateType) {
      case DateTimePickerType.date:
        return `${year}-${month}-${day}`;
      case DateTimePickerType.time:
        return `${hours}:${minutes}`;
      case DateTimePickerType.datetime:
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const defaultValue = fieldConfig.defaultValue? formatDateTime(fieldConfig.defaultValue):null;
  
  console.log(defaultValue,"fieldConfig.defaultValue")
  const [value, setValue] = useState(defaultValue || "");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(event.target.value,"event.target.value")
    setValue(event.target.value);
    onFieldChange(name, event.target.value);
  };

  const clearField = () => {
    setValue("");
    onFieldChange(name, "");
  };
  console.log("datetime field")
  return (
    <Form>
      <Input
        onChange={handleChange}
        onBlur={onBlur}
        onFocus={onFocuse}
        value={value}
        $colorState={colorState}
        $isActive={true}
        type={dateType}
        name={name}
        placeholder=" " // Ensures :placeholder-shown is not triggered when empty
      />
      <Label htmlFor={name} $isActive={isActive} $colorState={colorState}>
        {label}
      </Label>
      <IconContiner>
        {value !== "" && <Clear onClick={clearField}>✖</Clear>}
        {colorState === ColorState.success && <Icon src={Success} />}
        {colorState === ColorState.error && <Icon src={Error} />}
      </IconContiner>
    </Form>
  );
};

const Form = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
`;

const Label = styled.label<{ $colorState: ColorState, $isActive: boolean }>`
  position: absolute;
  right: 10px;
  top: 15px;
  color: ${props => props.$colorState === ColorState.error ? Colors.error : Colors.placeholder};
  background: ${Colors.whiteBackground};
  padding: 0 5px;
  transition: all 0.3s ease;
  transform: ${props => props.$isActive ? 'translateY(-23px)' : 'translateY(0px)'};
  font-size: ${props => props.$isActive ? '12px' : '16px'};
  pointer-events: none;
`;

const Input = styled.input<{ $isActive: boolean, $colorState: ColorState }>`
text-align: right;
  height: 44px;
  padding-right: 10px;
  border: 1px solid ${props => props.$colorState === ColorState.error ? Colors.error : Colors.fieldBorder};
  border-radius: 8px;
  outline: none;
  font-size: 16px;
  &:hover {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  }
  &:focus {
    border-color: ${props => props.$colorState === ColorState.error ? Colors.error : Colors.primary};
  }
  &:focus + ${Label}, &:not(:placeholder-shown) + ${Label} {
    transform: translateY(-23px);
    font-size: 12px;
    color: ${props => props.$colorState === ColorState.error ? Colors.error : Colors.primary};
  }
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
`;

const Clear = styled.button`
  width: 20px;
  font-size: 15px;
  border: none;
  background: transparent;
  margin: -2px 0;
  padding: 0;
  height: 10px;
`;

const IconContiner = styled.div`
  position: absolute;
  display: flex;
  justify-content: flex-start;
  left: 12px;
  gap: 5px;
  top: 15px;
`;